import { PageViewedTracker } from '@zenbusiness/application-commons-clickstream';
import { WebView } from '@zenbusiness/application-commons-webview';
import Box from '@zenbusiness/zui/Box';
import { useLocation } from 'react-router-dom';

import { Breadcrumbs } from '#client/components/Breadcrumbs';
import { DisableLayer } from '#client/components/DisableLayer';
import { FocusGrid, HubContainerGridStyled, HubMainWrapperStyled } from '#client/components/Grid';
import Notifications from '#client/components/Notifications';
import StatementContent from '#client/components/StatementsModal/components/StatementContent/StatementContent';
import useBreakpoints from '#client/hooks/useBreakpoints';
import useDisableDashboardContext from '#client/hooks/useDisableDashboardContext';

import { BreadcrumbWrapStyled } from '../SharedStyles';

const { isWebView } = WebView;

export default function Statements() {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const { isDisable } = useDisableDashboardContext();
  const pathname = useLocation();
  const properties = {
    key: pathname,
    appPageName: 'active_banking_dashboard',
    customDestinationPageName_: 'statements_screen'
  };

  return (
    <HubContainerGridStyled height="100%">
      <PageViewedTracker {...properties} />
      <FocusGrid height="100%">
        <HubMainWrapperStyled height={isMobile ? 'auto' : '100%'}>
          {!isWebView && (
            <BreadcrumbWrapStyled>
              <Breadcrumbs
                items={[
                  {
                    to: '../../finances',
                    label: 'Finances'
                  },
                  {
                    to: '../dashboard',
                    label: 'Banking'
                  },
                  {
                    label: 'Statements & Documents'
                  }
                ]}
              />
            </BreadcrumbWrapStyled>
          )}
          <Notifications />
          <Box position="relative">
            {isDisable && <DisableLayer aria-label="Disable layer" />}
            <StatementContent openOnPage />
          </Box>
        </HubMainWrapperStyled>
      </FocusGrid>
    </HubContainerGridStyled>
  );
}
